/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

/* eslint-disable  @typescript-eslint/no-explicit-any */
export interface Logger {
  logEvent: (
    event: string,
    params?: Record<string, any>,
    type?: LoggerProviderType | LoggerProviderType[],
  ) => void;
  logError: (
    error: unknown,
    context?: Record<string, any>,
    type?: LoggerProviderType | LoggerProviderType[],
  ) => void;
  logScreenView: (
    screen: string,
    params?: Record<string, any>,
    type?: LoggerProviderType | LoggerProviderType[],
  ) => void;
  debug?: (message?: any, ...optionalParams: any[]) => void;
  info?: (message?: any, ...optionalParams: any[]) => void;
  warn?: (message?: any, ...optionalParams: any[]) => void;
  error?: (message?: any, ...optionalParams: any[]) => void;
  // Optional utilities
  logDebug?: (message: string, meta?: Record<string, any>) => void;
  logInfo?: (message: string, meta?: Record<string, any>) => void;
  logWarn?: (message: string, meta?: Record<string, any>) => void;
  logFatal?: (error: Error, context?: Record<string, any>) => void;
}

export enum LoggerProviderType {
  firebase = 'firebase',
  moengage = 'moengage',
  conviva = 'conviva',
  appsflyer = 'appsflyer',
  all = 'all',
}
